import React from "react";
import { Reveal } from "./AboutMe.styles";
import { useInView } from "./useInView";

interface RevealSectionProps {
  delay?: number;
  children: React.ReactNode | ((inView: boolean) => React.ReactNode);
}

export const RevealSection: React.FC<RevealSectionProps> = ({
  delay = 0,
  children
}) => {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <Reveal ref={ref} $show={inView} $delay={delay}>
      {typeof children === "function"
        ? (children as (value: boolean) => React.ReactNode)(inView)
        : children}
    </Reveal>
  );
};
